// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2Hunm","title":"Images45_title__129Lr","images":"Images45_images__2vzjU"};